/**
 * Id for one import run, stamped on every sale it creates so the batch can be traced or
 * reverted. Readable on purpose — someone reading the sales table should be able to tell
 * when the import ran without joining anything.
 */
export const createImportBatchId = (now: Date = new Date(), random: () => number = Math.random): string => {
  const pad = (value: number, length = 2): string => String(value).padStart(length, '0')
  const stamp =
    `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}` +
    `-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
  const suffix = Math.floor(random() * 0x1000000)
    .toString(16)
    .padStart(6, '0')
  return `import-${stamp}-${suffix}`
}
